<template>
    <div class="describe">
      <div class="container banner">
        <img src="../../static/img/describe/banner.png" alt="">
        <div class="content-d">
          <ul>
            <li class="anchor" v-for="(item,index) in anthorList" :key='item.id' @click="scrollTo(index)">{{item.name}}</li>
          </ul>
          <div style="clear:both;"></div>
        </div>
      </div>
      <div class="container-d nutrition">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span> 热情贴心 <span class="title-line"></span></p>
          <h3 class="sub-title">24h妈妈照护</h3>
          <div class="nurse-box">
            <div class="img-box">
              <img src="../../static/img/describe/care-1.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">合美将对每位妈妈进行产前健康顾问
                服务、孕期营养保健咨询指导</div>
            </div>
            <div class="img-box">
              <img src="../../static/img/describe/care-2.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">月子期间采用四阶段模式并提供N对1、1对1服务，24h专属照护生活起居和健康保障，除每日护理外，产科、康复专家及月子美容管家等将定期巡检，提供更科学安心的月子照顾</div>
            </div>
            <div class="img-box">
              <img src="../../static/img/describe/care-3.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">入住时妇、产、儿、心理、营养等专家
                将全面健康评估，量身定制护理计划及
                月子膳食</div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
      </div>
      <div class="container-d health">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span>  10重安全护理  <span class="title-line"></span></p>
          <h3 class="sub-title">婴儿专业护理</h3>
          <div class="recover-box">
            <div class="recover-case case-w" v-for="item in healthL" :key="item.id">
              <img :src="item.src" alt="">
              <div class="case-text">
                <div class="case-describe">{{item.cons}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-d nutrition">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span>  三阶段定制月子餐  <span class="title-line"></span></p>
          <h3 class="sub-title">台式月子膳食</h3>
          <div class="nurse-box">
            <div class="img-box">
              <img src="../../static/img/describe/food-1.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">合美台式月子餐采取“一清、二调、三补、四强化”
                的食疗原则分阶段进行，打破传统误区，科学搭配
                膳食。</div>
            </div>
            <div class="img-box">
              <img src="../../static/img/describe/food-2.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">由专业营养师及台湾著名月子餐药膳调理师采用药食同源的方式为妈妈们量身定制月子餐，促进伤口愈合，进补气血调理体质，美容降脂强化</div>
            </div>
            <div class="img-box">
              <img src="../../static/img/describe/food-3.png" alt="">
            </div>
            <div class="text-box">
              <div class="nurse-con">每日三次主食、三次点心，上百样菜式确保28天
                不重复，让妈妈们吃出美丽，吃出健康。</div>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>
      </div>
      <div class="container-d health">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span> 科学早早教 <span class="title-line"></span></p>
          <h3 class="sub-title">新生儿早早教</h3>
          <div class="recover-box">
            <div class="recover-case case-w" v-for="item in educateL" :key="item.id">
              <img :src="item.src" alt="">
              <div class="case-text">
                <div class="case-describe">{{item.cons}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-d recover">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span> 4大疗养体系 <span class="title-line"></span></p>
          <h3 class="sub-title">产后康复保健</h3>
          <div class="recover-box">
            <div class="recover-case" v-for="item in recoverL" :key="item.id">
              <img :src="item.src" alt="">
              <div class="case-text">
                <div class="case-describe">{{item.cons}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-d health">
        <div class="content-d">
          <p class="meal-title"><span class="title-line"></span>  6大专业指导  <span class="title-line"></span></p>
          <h3 class="sub-title">产后纤体塑形</h3>
          <div class="recover-box">
            <div class="recover-case case-w" v-for="item in moulding" :key="item.id">
              <img :src="item.src" alt="">
              <div class="case-text">
                <div class="case-describe">{{item.cons}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="aside-nav">
        <ul class="nav-list" v-if="aside">
          <li class="nav-item" v-for="(item,index) in anthorList" :key="item.id" @click="scrollTo(index)">
            {{item.name}}
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
    export default {
        name: "describe",
      data(){
          return{
            aside:false,
            active:0,
            anthorList:[
              {
                id:1,
                name:'24h妈妈照护',
                src:''
              },
              {
                id:2,
                name:'婴儿专业护理',
                src:''
              },
              {
                id:3,
                name:'台式月子膳食',
                src:''
              },
              {
                id:4,
                name:'新生儿早早教',
                src:''
              },
              {
                id:5,
                name:'产后康复保健',
                src:''
              },
              {
                id:6,
                name:'产后纤体塑形',
                src:''
              }
            ],
            healthL:[
              {
                id:1,
                src:'../../static/img/describe/health-1.png',
                cons:'资深儿科专家对宝宝进行健康评估、定期查房，观察宝宝生长发育情况、喂养\n' +
                  '情况，双证护士每日观察并测量，记录宝宝体温、体重、心跳、呼吸灯体征，帮助宝宝每日洗澡并抚触按摩'
              },
              {
                id:2,
                src:'../../static/img/describe/health-2.png',
                cons:'五星配套设施 + 独立的婴儿室，可根据妈妈需求提供24小时宝宝托管服务，帮助宝宝培养良好的睡眠习惯及姿势，让妈妈有足够的休息，回到家也可以轻松照顾宝宝。'
              },
            ],
            educateL:[
              {
                id:1,
                src:'../../static/img/describe/educate-1.png',
                cons:'如果要发挥人脑的最大潜能，应特别重视0-3岁的早期教育。从宝宝出生到整个月子期间，都可以进行早早教活动，合美早早教服务主要是从视觉、听觉、触觉、四肢等多方面进行训练，可以有效刺激宝宝感官能力发展、促进智力和骨骼的发育。'
              },
              {
                id:2,
                src:'../../static/img/describe/educate-2.png',
                cons:'如果要发挥人脑的最大潜能，应特别重视0-3岁的早期教育。从宝宝出生到整个月子期间，都可以进行早早教活动，合美早早教服务主要是从视觉、听觉、触觉、四肢等多方面进行训练，可以有效刺激宝宝感官能力发展、促进智力和骨骼的发育。'
              },
            ],
            recoverL:[
              {
                id:1,
                src:'../../static/img/describe/recover-1.png',
                cons:'合美“纤之韵”产康团队由留美医学博士、和睦家产康专家张晓东博士定期坐诊，其团队为孕妈提供顶级专业的产后康复服务，深度解决剖析问题制定康复计划。包括臀部恢复、盆骨矫正、盆骨肌腹直肌修复、肚子恢复等，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，让骨盆恢复自然生理机能。'
              },
              {
                id:2,
                src:'../../static/img/describe/recover-2.png',
                cons:'合美“纤之韵”产康团队由留美医学博士、和睦家产康专家张晓东博士定期坐诊，其团队为孕妈提供顶级专业的产后康复服务，深度解决剖析问题制定康复计划。包括臀部恢复、盆骨矫正、盆骨肌腹直肌修复、肚子恢复等，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，让骨盆恢复自然生理机能。'
              },
            ],
            moulding:[
              {
                id:1,
                src:'../../static/img/describe/mould-1.png',
                cons:'合美产后形体修复以专业按摩手法、配合中医点穴与塑腹技巧，使产后腹部上变大变松的脂肪粒压缩变小变实，增加弹性纤维的韧性以及表皮的弹性，使腰部结实；在印尼古法基础上依据产后妈妈整体身体结构设计改良，配合修复主打产品“JAMU”“CHIMU”黑科技局部紧致，帮助新妈妈快速恢复，完美纤体，重归自信。'
              },
              {
                id:2,
                src:'../../static/img/describe/mould-2.png',
                cons:'合美产后形体修复以专业按摩手法、配合中医点穴与塑腹技巧，使产后腹部上变大变松的脂肪粒压缩变小变实，增加弹性纤维的韧性以及表皮的弹性，使腰部结实；在印尼古法基础上依据产后妈妈整体身体结构设计改良，配合修复主打产品“JAMU”“CHIMU”黑科技局部紧致，帮助新妈妈快速恢复，完美纤体，重归自信。'
              },
            ],

          }
      },
      mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.onScroll, false)
      },
      destroy() {
        // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
        window.removeEventListener('scroll', this.onScroll)
      },
      methods: {
        onScroll() {
          // 获取所有锚点元素
          const navContents = document.querySelectorAll('.container-d')
          // 所有锚点元素的 offsetTop
          const offsetTopArr = [];
          for(var i=0;i<navContents.length;i++){
            offsetTopArr.push(navContents[i].offsetTop)
          }
          // 获取当前文档流的 scrollTop
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          if(scrollTop>=300){
            this.aside = true
          }else{
            this.aside = false
          }
          // 定义当前点亮的导航下标
          let navIndex = 0;
          for (let n = 0; n < offsetTopArr.length; n++) {
            // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
            // 那么此时导航索引就应该是n了
            if (scrollTop >= offsetTopArr[n]) {
              navIndex = n
            }
          }
          this.active = navIndex
        },
        // 跳转到指定索引的元素
        scrollTo(index) {
          // 获取目标的 offsetTop
          // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
          const targetOffsetTop = document.querySelector(`.container-d:nth-child(${index + 2})`).offsetTop;
          // 获取当前 offsetTop
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
          const STEP = 50
          // 判断是往下滑还是往上滑
          if (scrollTop > targetOffsetTop) {
            // 往上滑
            smoothUp()
          } else {
            // 往下滑
            smoothDown()
          }

          // 定义往下滑函数
          function smoothDown() {
            // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
            if (scrollTop < targetOffsetTop) {
              // 如果和目标相差距离大于等于 STEP 就跳 STEP
              // 否则直接跳到目标点，目标是为了防止跳过了。
              if (targetOffsetTop - scrollTop >= STEP) {
                scrollTop += STEP
              } else {
                scrollTop = targetOffsetTop
              }
              document.body.scrollTop = scrollTop
              document.documentElement.scrollTop = scrollTop
              // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
              requestAnimationFrame(smoothDown)
            }
          }
          function smoothUp() {
            if (scrollTop > targetOffsetTop) {
              if (scrollTop - targetOffsetTop >= STEP) {
                scrollTop -= STEP
              } else {
                scrollTop = targetOffsetTop
              }
              document.body.scrollTop = scrollTop
              document.documentElement.scrollTop = scrollTop
              requestAnimationFrame(smoothUp)
            }
          }
        }
      }
    }
</script>

<style scoped lang="less">

.describe{
  .aside-nav{
    position: fixed;
    left: calc(50% + 560px);
    top: 300px;
    .nav-item{
      width: 132px;
      height: 40px;
      font-size: 16px;
      padding: 8px;
      text-align: center;
      background-color: #e0e0e0;
      color: #333333;
      border: 1px solid #ffffff;
      cursor: pointer;
      &:hover{
        background-color: #f79200;
        color:#ffffff;
      }
    }
  }
  .banner{
    background-color: #f9f9f9;
    border-bottom: 1px solid #e5e5e5;
    img{
      width: 100%;
    }
    .content-d{
      ul{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .anchor{
          float: left;
          line-height: 55px;
          font-size: 16px;
          cursor: pointer;
        }
      }

    }
  }
  .recover{
    padding: 80px 0;
  }
  .nurse{
    padding: 80px 0;
    background-color: #fff8f4;
    .nurse-box{
      margin-top: 50px;
      .img-box,.text-box{
        float: left;
        width: 33%;
        height: 240px;
        background-color: #fff;
      }
      .img-box{
        img{
          width: 100%;
          height: 100%;
        }
      }
      .text-box{
        padding: 0 42px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .nurse-title{
          font-size: 20px;
          margin-bottom: 12px;
        }
        .nurse-con{
          color: #666666;
        }
      }
    }
  }
  .nutrition{
    padding: 80px 0;
    .nurse-box{
      margin-top: 50px;
      .img-box,.text-box{
        float: left;
        width: 33%;
        height: 240px;
        background-color: #f7f7f7;
      }
      .img-box{
        img{
          width: 100%;
          height: 100%;
        }
      }
      .text-box{
        padding: 0 42px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .nurse-title{
          font-size: 20px;
          margin-bottom: 12px;
        }
        .nurse-con{
          color: #666666;
        }
      }
    }
  }
  .health{
    padding: 80px 0;
    background-color: #fff8f4;
  }
  .enlighten{
    padding: 80px 0;
  }
  .server{
    padding: 80px 0;
    background-color: #fff8f4;
    .nurse-box{
      margin-top: 50px;
      .img-box,.text-box{
        float: left;
        width: 33%;
        height: 240px;
        background-color: #ffffff;
      }
      .img-box{
        img{
          width: 100%;
          height: 100%;
        }
      }
      .text-box{
        padding: 0 42px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .nurse-title{
          font-size: 20px;
          margin-bottom: 12px;
        }
        .nurse-con{
          color: #666666;
        }
      }
    }
  }
  .mould{
    padding: 80px 0;
    .mould-list{
      margin-top: 50px;
      .mould-item{
        transition: all 0.5s;
        cursor: pointer;
        width: 530px;
        height: 220px;
        float: left;
        margin:0 40px 40px 0;
        img{
          float: left;
          width: 240px;
          height: 220px;
          background-color: #999999;
        }
        .mould-info{
          float: left;
          width: 290px;
          height: 220px;
          padding: 42px 28px;
          background-color: #f8f8f8;
          .mould-title{
            font-size: 20px;
            margin-bottom: 20px;
          }
          .mould-con{
            color: #666666;
          }
        }
        &:nth-child(2n){
          margin-right: 0;
        }
        &:hover{
          transform: scale(1.1);
        }
      }
    }
  }
  .safeguard{
    background-color: #fff8f4;
    padding: 80px 0;
  }
  .all-weather{
    padding: 80px 0;
  }
}
.recover-box{
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .recover-case{
    width: 530px;
    height: 515px;
    background-color: #f7f7f7;
    img{
      width: 100%;
      height: 360px;
    }
    .case-text{
      padding: 30px;
      color:#666666;
      .case-title{
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
  }
  .case-w{
    background-color: #fff;
  }
}

.container-d {
  width: 100%;
  min-width: 1100px;
}
.content-d {
  width: 1100px;
  margin:0 auto;
  box-sizing: border-box;
}
.meal-title{
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  color:#666666;
  .title-line{
    width: 50px;
    height: 1px;
    margin:0 20px;
    display: inline-block;
    background-color: #666666;
    vertical-align: middle;
  }
}
.sub-title{
  color:#333333;
  font-size: 36px;
  text-align: center;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/describe.vue